<app-error text="expired_token_error.text" [title]="'expired_token_error.oops'"></app-error>
